import { useCallback, useState } from "react";

import { ImmutableMapOperations } from "../collections";

interface UseSelectionReturn<TItem> {
    selectedItems: ReadonlyMap<string, TItem>;
    toggleItemSelection: (item: TItem) => void;
    resetSelection: () => void;
}

export const useSelection = <TItem>(getKey: (item: TItem) => string): UseSelectionReturn<TItem> => {
    const [selectedItems, setSelectedItems] = useState<ReadonlyMap<string, TItem>>(new Map());

    const toggleItemSelection = useCallback<(item: TItem) => void>(
        (item) => {
            if (selectedItems.has(getKey(item))) {
                setSelectedItems(ImmutableMapOperations.delete(selectedItems, getKey(item)));
            } else {
                setSelectedItems(ImmutableMapOperations.set(selectedItems, getKey(item), item));
            }
        },
        [selectedItems, getKey],
    );

    const resetSelection = useCallback(() => {
        setSelectedItems(new Map());
    }, [setSelectedItems]);

    return {
        selectedItems,
        toggleItemSelection,
        resetSelection,
    };
};
